import React, { useRef } from "react";
import { Modal, Button } from "antd";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import "./style.css";
// import Companyseal from "../../Assets/Images/seal.JPG";
import Companyseal from "../../Assets/Images/sahari-seal.png";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

function DownloadPackingInvoiceModal(props) {
  const componentRef = useRef();

  return (
    <Modal
      visible={props.visible}
      onOk={() => props.onClose()}
      onCancel={() => props.onClose()}
      width={900}
      footer={null}
    >
      <div ref={componentRef}>
        <div
          className="print-invoice-page"
          style={{
            height: "max-content",
            padding: "20px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <h2 style={{ fontSize: "18px", fontWeight: "bold", margin: "0" }}>
              UPB / GIFT CARGO DECLARATION FORM
            </h2>
            <div style={{ fontSize: "14px", marginTop: "10px" }}>
              TO : DIRECTOR GENERAL OF CUSTOMS
            </div>
          </div>

          {/* Sender and Receiver Information */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "10px" }}>
            {/* Sender Information */}
            <div
              style={{ flex: 1, border: "2px solid black", padding: "10px" }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                SENDER / SHIPPER INFORMATION
              </div>
              <div style={{ fontSize: "12px", lineHeight: "1.8" }}>
                <div>NAME: {props?.item?.collection?.sender_name}</div>
                <div>ADDRESS: {props?.item?.collection?.sender_address}</div>
                <div>ID NO: {props?.item?.iqama_number}</div>
                <div>CONTACT NO: {props?.item?.collection?.sender_phone}</div>
                <div>EMAIL: {props?.item?.collection?.sender_email ?? "-"}</div>
              </div>
            </div>

            {/* Receiver Information */}
            <div
              style={{ flex: 1, border: "2px solid black", padding: "10px" }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                RECEIVER / CONSIGNEE INFORMATION
              </div>
              <div style={{ fontSize: "12px", lineHeight: "1.8" }}>
                <div>NAME: {props?.item?.collection?.reciver_name}</div>
                <div>ADDRESS: {props?.item?.collection?.sender_address}</div>
                <div>ID NO: {props?.item?.adhar_no}</div>
                <div>CONTACT NO: {props?.item?.collection?.reciver_phone}</div>
                <div>
                  EMAIL: {props?.item?.collection?.reciver_email ?? "-"}
                </div>
              </div>
            </div>
          </div>
          {/* Items Declaration Table */}
          <div style={{ marginBottom: "10px" }}>
            <table
              style={{
                width: "100%",
                border: "2px solid black",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f0f0f0" }}>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "8px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      width: "8%",
                    }}
                  >
                    PKG NO
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "8px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      width: "8%",
                    }}
                  >
                    ITEM NO
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "8px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      width: "54%",
                    }}
                  >
                    DESCRIPTION OF GOODS
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "8px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      width: "15%",
                    }}
                  >
                    QUANTITY
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "8px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      width: "15%",
                    }}
                  >
                    VALUE
                  </th>
                </tr>
              </thead>
              <tbody>
                {props?.item?.boxe_item?.map((item, index) => {
                  return (
                    <tr>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "11px",
                          paddingRight: "10px",
                        }}
                      >
                        {props?.item?.box_number}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "11px",
                          alignItems: "center",
                        }}
                      >
                        {item?.item}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >
                        {item?.quantity}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >
                        {item?.value}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* Certification Sections */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "10px" }}>
            {/* Sender Certification */}
            <div
              style={{ flex: 1, border: "2px solid black", padding: "15px" }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                I CERTIFY THAT, THE ABOVE DETAILS ARE TRUE AND CORRECT.
              </div>

              <div style={{ marginTop: "20px", fontSize: "11px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minHeight: "80px",
                    marginBottom: "10px",
                  }}
                >
                  {props?.item?.signature ? (
                    <img
                      src={props?.item?.signature}
                      style={{
                        maxHeight: "80px",
                        maxWidth: "150px",
                        objectFit: "contain",
                        display: "block",
                        border: "1px solid #ccc",
                        padding: "5px",
                        backgroundColor: "white",
                      }}
                      crossOrigin="anonymous"
                      alt="Sender Signature"
                    />
                  ) : (
                    <div
                      style={{
                        height: "80px",
                        width: "150px",
                        border: "1px solid #ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f9f9f9",
                        fontSize: "10px",
                        color: "#666",
                      }}
                    >
                      No Signature
                    </div>
                  )}
                </div>
                <div
                  style={{
                    borderTop: "1px solid black",
                    marginTop: "10px",
                    paddingTop: "10px",
                    textAlign: "center",
                    fontSize: "10px",
                  }}
                >
                  SIGNATURE OF SENDER / CONSIGNOR
                  <br />
                </div>
                <br />
                <div
                  style={{
                    borderBottom: "1px solid black",
                    marginBottom: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {props?.item?.collection?.sender_name}
                </div>
                <div
                  style={{
                    fontSize: "11px",
                    marginBottom: "5px",
                    textAlign: "center",
                  }}
                >
                  NAME
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "15px",
                  }}
                >
                  <div
                    style={{
                      borderBottom: "1px solid black",
                      width: "45%",
                      paddingBottom: "5px",
                    }}
                  >
                    {props?.item?.collection?.sender_iqama ?? "-"}
                  </div>
                  <div
                    style={{
                      borderBottom: "1px solid black",
                      width: "45%",
                      paddingBottom: "5px",
                    }}
                  >
                    {moment().format("DD-MM-YYYY")}, RIYADH
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "11px",
                    marginTop: "5px",
                  }}
                >
                  <div style={{ width: "45%", textAlign: "center" }}>ID NO</div>
                  <div style={{ width: "45%", textAlign: "center" }}>
                    DATE & PLACE
                  </div>
                </div>
              </div>
            </div>

            {/* Agent Certification */}
            <div
              style={{ flex: 1, border: "2px solid black", padding: "15px" }}
            >
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "left",
                }}
              >
                CERTIFICATION BY THE AGENT
              </div>
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "left",
                  fontWeight: "bold",
                }}
              >
                SAHARI CARGO
              </div>

              <div style={{ fontSize: "11px", lineHeight: "2" }}>
                <div>NO. OF PACKAGES: {props?.item?.boxe_item?.length}</div>
                <div>WEIGHT: {props?.item?.chargable_weight} KG</div>
                <div>VOLUME: {props?.item?.volume_weight} CBM</div>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  textAlign: "center",
                  paddingTop: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minHeight: "80px",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={Companyseal}
                    style={{
                      maxHeight: "80px",
                      maxWidth: "120px",
                      objectFit: "contain",
                      display: "block",
                      backgroundColor: "white",
                    }}
                    crossOrigin="anonymous"
                    alt="Company Seal"
                  />
                </div>
                <div
                  style={{
                    fontSize: "10px",
                    marginTop: "10px",
                    borderTop: "1px solid black",
                    paddingTop: "5px",
                    textAlign: "center",
                  }}
                >
                  SIGNATURE & AGENT SEAL
                </div>
              </div>
            </div>
          </div>
          {/* Warning Notice */}
          <div
            style={{
              marginTop: "10px",
              padding: "5px",
              border: "2px solid black",
              backgroundColor: "#f9f9f9",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              WARNING: FALSE OR NON-DECLARATION IS AN OFFENCE AND MAY INVOLVE
              HEAVY PENALTIES INCLUDING FORFEITURE, UNDER THE CUSTOMS ORDINANCE
            </div>
          </div>
        </div>
      </div>

      <Row>
        <Col sm="6"></Col>

        <Col sm="3" xs="3">
          <Button onClick={() => props.onClose()} block size="large">
            Cancel
          </Button>
        </Col>
        <Col sm="3" xs="3">
          <Button
            type="primary"
            size="large"
            block
            onClick={() => {
              const content = componentRef.current;
              var w = content.offsetWidth;
              var h = content.offsetHeight;
              html2canvas(content, {
                useCORS: true,
                allowTaint: true,
                dpi: 300, // Set to 300 DPI
                scale: 3, // Adjusts your resolution
              }).then((canvas) => {
                var img = canvas.toDataURL("image/jpeg", 1);
                var doc = new jsPDF();
                // var width = doc.internal.pageSize.getWidth();
                var width = 225;
                var height = doc.internal.pageSize.getHeight();
                console.log("width", width);
                doc.addImage(img, "JPEG", 0, 0, width, height);
                doc.save(`${props.item.box_number}.pdf`);
              });
            }}
          >
            Download PDF
          </Button>
        </Col>
      </Row>
    </Modal>
  );
}
export default DownloadPackingInvoiceModal;
